import TestemunhoIndividual from './TestemunhoIndividual';

function SeuLele() {
    return <TestemunhoIndividual testimonialId={2} />;
}

export default SeuLele;
